'use client'
import { useState, useEffect } from 'react'
import { ONE } from 'config/apis'
import Table from 'components/Table'
import Spin from 'components/Spin'

const tableHeaders = [
  'CLUB/NOM',
  'LOCALITAT',
  'TELÈFON',
  'E-MAIL',
  'Nº PISTES',
  'WEB'
]

const TableClubs = () => {
  const [loading, setLoading] = useState(false)
  let filtersBase = [
    {
      name: 'locality',
      keyName: 'keyName',
      options: [{ Id: '', Value: 'Selecciona una locatitat' }]
    }
  ]
  const resultsByPage = 5
  const [clubs, setClubs] = useState()
  const [filters, setFilters] = useState(filtersBase)
  const [activeFilters, setActiveFilters] = useState({
    locality: '',
    page: 1
  })
  const [pageDynamically, setPageDynamically] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)

  const getFilters = async () => {
    try {
      const reqFilters = await fetch(ONE.CLUBS_LOCALITIES, ONE.HEADERS)
      const filtersData = (await reqFilters.json()).Data.Localities
      const localities = filtersData.map(({ locality }) => ({
        Id: locality,
        Value: locality
      }))
      filtersBase[0].options = [...filtersBase[0].options, ...localities]
      setFilters(filtersBase)
    } catch (err) {
      console.log(err)
    }
  }

  const getClubs = async () => {
    setLoading(true)
    try {
      const res = await fetch(
        `${ONE.CLUBS_LIST}?locality=${activeFilters.locality}&limit=${resultsByPage}&page=${activeFilters.page}`,
        ONE.HEADERS
      )
      const _clubs = await res.json()
      setTotalRecords(_clubs.TotalRecords)
      const clubsForTable = _clubs.Data.map(
        ({ name, locality, phone, mail, courts, web }) => ({
          0: name,
          1: locality,
          2: phone,
          3: (
            <a
              href={`mailto:${mail}`}
              target="_blank"
              rel="noreferrer"
              className="hover:underline"
            >
              {mail}
            </a>
          ),
          4: courts,
          5: (
            <a
              href={`https://${web}`}
              target="_blank"
              rel="noreferrer"
              className="hover:underline"
            >
              {web}
            </a>
          )
        })
      )
      setClubs(clubsForTable)
    } catch (err) {
      console.log(err)
    }
    setLoading(false)
  }

  useEffect(() => {
    const newFilter = { ...activeFilters }
    newFilter.page = pageDynamically
    setActiveFilters(newFilter)
  }, [pageDynamically])

  useEffect(() => {
    getClubs()
  }, [activeFilters])

  useEffect(() => {
    getFilters()
    getClubs()
  }, [])

  return (
    <>
      <div className="max-w-7xl mx-auto my-10 lg:my-28">
        <div className="grid grid-cols-1 gap-2 lg:flex bg-sec-grey-4 rounded-lg py-4 lg:py-6 mb-8 px-4">
          {filters &&
            filters.map((item, idx) => {
              return (
                <div key={idx} className="w-full lg:w-auto">
                  <select
                    name={item?.name}
                    className="bg-grey w-full border-none text-blue font-alliance-medium text-[18px] lg:text-[20px] h-12 lg:h-16 rounded-sm focus:ring-0 mr-4"
                    onChange={(e) => {
                      const newFilter = { ...activeFilters }
                      newFilter[e.target.name] = e.target.value
                      setActiveFilters(newFilter)
                    }}
                  >
                    {item?.options?.map((option, oidx) => {
                      return (
                        <option key={oidx} value={option?.Id}>
                          &nbsp;&nbsp;&nbsp;{option?.Value}
                        </option>
                      )
                    })}
                  </select>
                </div>
              )
            })}
        </div>
        {loading ? (
          <div className="flex justify-center my-20">
            <Spin color="text-blue" size="10" className="my-2 lg:my-8" />
          </div>
        ) : (
          clubs && (
            <div className="mb-24">
              <Table
                headers={tableHeaders}
                content={clubs}
                cols={6}
                rows={resultsByPage}
                pageDynamically={pageDynamically}
                setPageDynamically={setPageDynamically}
                totalRecords={totalRecords}
                center={true}
              />
            </div>
          )
        )}
      </div>
    </>
  )
}

export default TableClubs
